import { statusExtra } from '../constants';
import i18n from '../i18n';

const getFallbackCode = (code) =>
  typeof code === 'string' && code.startsWith('RETURNED-') ? 'RETURNED' : null;

export const describeStatus = (type, code, method) => {
  const fallbackCode = getFallbackCode(code);
  const typeExtra = statusExtra[type] || {};
  const extraStatusInfo =
    typeExtra[code] || (fallbackCode && typeExtra[fallbackCode]) || {};
  if (method && method === 'OPEN_INVOICE' && code === 'NOT_PAID') {
    return {
      code,
      label: i18n.t(`status:${type}Status.NOT_PAID_INVOICE`),
      ...extraStatusInfo,
    };
  }
  const keys = [`status:${type}Status.${code}`];
  if (fallbackCode) {
    keys.push(`status:${type}Status.${fallbackCode}`);
  }

  return {
    code,
    label: i18n.t(keys),
    ...extraStatusInfo,
  };
};

export const getCardExpiryStatus = (cardExpiry, t) => {
  const [mm, yy] = cardExpiry.split('/').map(Number);

  if (!mm && !yy) {
    return false;
  }

  const fullYear = yy.toString().length === 2 ? 2000 + yy : yy;
  const expirationDate = new Date(fullYear, mm);
  const now = new Date();
  const thresholdDate = new Date(now.getFullYear(), now.getMonth() + 2);

  if (now >= expirationDate) {
    return t('common:creditCardExpire');
  } else if (expirationDate <= thresholdDate) {
    return t('common:creditCardExpireSoon');
  }
};
